// Pre-cache satellite map tiles around a point so the festival map works offline.
const TILE_LAYERS = [
  "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile",
  "https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile",
];

function lon2tile(lon, z) {
  return Math.floor(((lon + 180) / 360) * Math.pow(2, z));
}
function lat2tile(lat, z) {
  const r = (lat * Math.PI) / 180;
  return Math.floor(((1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2) * Math.pow(2, z));
}

// Build tile URLs covering a grid around center for a set of zoom levels.
export function buildTileUrls(center, zooms = [15, 16, 17, 18], radius = 2) {
  const urls = [];
  for (const z of zooms) {
    const cx = lon2tile(center.lng, z);
    const cy = lat2tile(center.lat, z);
    for (let dx = -radius; dx <= radius; dx++) {
      for (let dy = -radius; dy <= radius; dy++) {
        const x = cx + dx;
        const y = cy + dy;
        for (const base of TILE_LAYERS) {
          urls.push(`${base}/${z}/${y}/${x}`);
        }
      }
    }
  }
  return urls;
}

export async function precacheArea(center) {
  if (!center) throw new Error("no location yet");
  const urls = buildTileUrls(center);
  // Prefer the service worker (handles opaque cross-origin responses cleanly).
  if (navigator.serviceWorker && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ type: "PRECACHE_TILES", urls });
    return urls.length;
  }
  // Fallback: fetch directly (the SW fetch handler will cache them if active).
  await Promise.all(urls.map((u) => fetch(u, { mode: "no-cors" }).catch(() => {})));
  return urls.length;
}
